import classNames from 'classnames'
import { Fragment } from 'react'
import { FaEllipsisV } from 'react-icons/fa'
import map from 'lodash/map'
import { Menu, Transition } from '@headlessui/react'
import propTypes from 'prop-types'


export default function Dropdown(props) {
  return (
    <Menu as='div' className={classNames('text-left relative', props.className)}>
      <Menu.Button
        className={classNames(
          'transition-all',
          'text-black font-medium',
          'border-0 outline-none ring-0 focus:outline-none text-center',
          'hover:text-primary-600',
          'p-2',
          props.buttonClassName,
        )}
      >
        <FaEllipsisV aria-hidden='true' />
      </Menu.Button>

      <Transition
        as={Fragment}
        enter='transition ease-out duration-100'
        enterFrom='transform opacity-0 scale-95'
        enterTo='transform opacity-100 scale-100'
        leave='transition ease-in duration-75'
        leaveFrom='transform opacity-100 scale-100'
        leaveTo='transform opacity-0 scale-95'
      >
        <Menu.Items
          className={classNames(
            'origin-top-right',
            'absolute',
            'mt-2',
            'rounded-md',
            'shadow-lg',
            'text-left',
            'bg-white ring-1 ring-black ring-opacity-5',
            'focus:outline-none z-10',
            props.itemClassName,
          )}
        >
          <div className='py-1'>
          {
            map(
              props.items,
              item => (
                <Menu.Item onClick={item.onClick} key={`menu_item_${item.label}`}>
                  {({ active }) => (
                    <span
                      className={
                        classNames([
                          {
                            'bg-gray-100 text-gray-900': active,
                            'text-gray-700': ! active,
                          },
                          'block px-4 py-2 cursor-pointer'
                        ])
                      }
                    >
                      {item.label}
                    </span>
                  )}
                </Menu.Item>
              )
            )
          }
          </div>
        </Menu.Items>
      </Transition>
    </Menu>
  )
}

Dropdown.propTypes = {
  className: propTypes.string,
  items: propTypes.arrayOf(propTypes.shape({
    label: propTypes.any.isRequired,
    onClick: propTypes.func,
  })),
}

Dropdown.defaultProps = {
}
